<template>
  <div class="teacher-add-form">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item label="姓名" label-width="120px" prop="teacherName">
        <el-input v-model="ruleForm.teacherName" autocomplete="off" placeholder="请输入教师姓名"></el-input>
      </el-form-item>
      <el-form-item label-width="120px" label="性别" required>
        <el-radio-group v-model="ruleForm.sex">
          <el-radio label="男"></el-radio>
          <el-radio label="女"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="工号" label-width="120px" prop="teacherNumber">
        <el-input v-model="ruleForm.teacherNumber" autocomplete="off" placeholder="请输入工号"></el-input>
      </el-form-item>
      <el-form-item label="手机号(账号)" label-width="120px" prop="phone">
        <el-input v-model="ruleForm.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="导师类型" label-width="120px" prop="mentorType">
        <el-select v-model="ruleForm.mentorType" multiple placeholder="请选择">
          <el-option v-for="item in mentorTypeList" :key="item.dictValue" :label="item.dictLabel"
            :value="item.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="form-btn">
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['mentorTypeList'],
  name: "",
  data() {
    let phoneCodeVerification = /^1[3-9][0-9]{9}$/;
    const validatePhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else if (!phoneCodeVerification.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        teacherName: "",
        teacherNumber: "",
        phone: "",
        mentorType: "",
        sex: "男",
      },
      rules: {
        teacherName: [
          { required: true, message: "请输入教师姓名", trigger: "blur" },
        ],
        teacherNumber: [
          { required: true, message: "请输入教师工号", trigger: "blur" },
        ],
        mentorType: [
          { required: false, message: "请选择导师类型", trigger: "change" },
        ],
        phone: [{ validator: validatePhone, required: true, trigger: "blur" }],
      },
    };
  },
  methods: {
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit("formSubmit", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    reset() {
      this.ruleForm = {
        teacherName: "",
        teacherNumber: "",
        phone: "",
        mentorType: "",
        sex: "男"
      };
      this.$refs["ruleForm"].clearValidate(); //移除表单检验结果
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./teacher-add-form.scss";
</style>